import { Invoice } from '../../types';
import BackendResponse from '@core/shared/backend-response';
import { HttpPostRequest } from '@infrastructure/axios/http-post-request';

export interface ISendSelectedInvoiceUseCase {
  execute(selectedInvoices: Array<number>): Promise<BackendResponse<Invoice[]>>;
}

export default class SendSelectedInvoiceToEmailUseCase extends HttpPostRequest<object, any> implements ISendSelectedInvoiceUseCase {
  public async execute(selectedInvoices: Array<number>): Promise<BackendResponse<any>> {
    const response = await this.dispatch('/invoices/email-full-report', { invoiceIds: selectedInvoices });
    return response.data;
  }
}
